import React from 'react';
import styles from '../../../styles/UserManagement.module.css';

interface TabNavigationProps {
    activeTab: string;
    onTabChange: (tab: 'users' | 'requests') => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, onTabChange }) => {
    return (
        <div className={styles.tabContainer}>
            <button
                className={`${styles.tabButton} ${activeTab === 'users' ? styles.activeTab : ''}`}
                onClick={() => onTabChange('users')}
            >
                Users
            </button>
            <button
                className={`${styles.tabButton} ${activeTab === 'requests' ? styles.activeTab : ''}`}
                onClick={() => onTabChange('requests')}
            >
                Pending Enrollments
            </button>
        </div>
    );
};

export default TabNavigation;
